export class Helper {

    /**
     * Добавить node после элемента referenceNode
     */
    public static insertAfter(node: HTMLElement, referenceNode: HTMLElement) {
        if (!node || !referenceNode) return;
        var parent = referenceNode.parentNode, nextSibling = referenceNode.nextSibling;
        if (nextSibling && parent) {
            parent.insertBefore(node, referenceNode.nextSibling);
        } else if (parent) {
            parent.appendChild(node);
        }
    }
}
